<template>
  <a-modal width="70%" :label-col="4" :wrapper-col="14" :visible="visible" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>修改商品单价</b>
    </a-divider>
    <a-form-model ref="formRef" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-table :data-source="listOrder" row-key="orderItemId" :pagination="false" size="small" bordered>
        <a-table-column title="商品名称" data-index="goodsName" width="260px" />
        <a-table-column title="数量" data-index="goodsCount" width="70px" align="center" />
        <a-table-column title="原成交单价" width="100px" align="right">
          <template slot-scope="text, row">¥{{ row.payPrice }}</template>
        </a-table-column>
        <a-table-column title="成本单价" width="100px" align="right">
          <template slot-scope="text, row">¥{{ row.costPrice }}</template>
        </a-table-column>
        <a-table-column title="零售单价" width="100px" align="right">
          <template slot-scope="text, row">¥{{ row.price }}</template>
        </a-table-column>
        <a-table-column title="特价商品" width="80px" align="center">
          <template slot-scope="text, row">
            <a-tag color="red" v-if="row.isSpecialPrice">是</a-tag>
            <a-tag color="#108ee9" v-else>否</a-tag>
          </template>
        </a-table-column>
        <a-table-column title="修改后单价" width="130px" align="center">
          <template slot-scope="text, row">
            <a-input-number v-model="row.newPayPrice" :min="0.01" :precision="2" style="width: 100%" />
          </template>
        </a-table-column>
      </a-table>

      <a-row style="margin-top: 16px;">
        <a-form-model-item label="运费">
          <a-input v-model="form.shippingPayAmount" disabled />
        </a-form-model-item>
        <a-form-model-item label="修改后实付金额">
          <a-input :value="newPayAmountText" disabled />
        </a-form-model-item>
        <a-form-model-item label="修改原因">
          <a-textarea v-model="form.approvalOpinion" :rows="3" :maxLength="500"
            placeholder="请填写修改原因（选填）" />
        </a-form-model-item>
      </a-row>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.确定') }}
          </a-button>
          <a-button type="dashed" @click="onClose">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updatePriceApi } from '@/api/order/sell'
export default {
  name: 'UpdatePrice',
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      // 表单参数
      form: {
        id: null,
        shippingPayAmount: null,
        approvalOpinion: undefined
      },
      listOrder: [],
      visible: false,
      rules: {}
    }
  },
  computed: {
    /** 修改后实付金额 = 各商品修改后单价×数量之和 + 运费 */
    newPayAmountText() {
      const shipping = Number(this.form.shippingPayAmount) || 0
      let goodsAmount = 0
      this.listOrder.forEach(row => {
        goodsAmount += (Number(row.newPayPrice) || 0) * (Number(row.goodsCount) || 0)
      })
      return '¥' + Number(goodsAmount + shipping).toFixed(2)
    }
  },
  methods: {
    open(row) {
      this.visible = true
      this.form.id = row.id
      this.form.shippingPayAmount = row.shippingPayAmount
      this.form.approvalOpinion = undefined
      this.listOrder = (row.orderItemList || []).map(item => ({
        ...item,
        // 默认修改后单价 = 当前成交单价
        newPayPrice: item.payPrice != null ? Number(item.payPrice) : undefined
      }))
    },
    // 取消按钮
    onClose() {
      this.visible = false
    },
    /** 前端校验，逻辑与后端一致 */
    validatePrice() {
      let newGoodsAmount = 0
      let totalCostPrice = 0
      let totalOriginalPrice = 0
      for (const row of this.listOrder) {
        const newPrice = Number(row.newPayPrice)
        const count = Number(row.goodsCount) || 0
        const costPrice = Number(row.costPrice) || 0
        const originalPrice = Number(row.price) || 0
        if (!newPrice || newPrice <= 0) {
          this.$message.warning('商品[' + row.goodsName + ']单价必须大于0')
          return false
        }
        // 普通商品：修改后单价不得低于成本单价
        if (!row.isSpecialPrice && newPrice < costPrice) {
          this.$message.warning('商品[' + row.goodsName + ']单价不能低于成本价' + costPrice.toFixed(2))
          return false
        }
        newGoodsAmount += newPrice * count
        totalCostPrice += costPrice * count
        totalOriginalPrice += originalPrice * count
      }
      const shippingPayAmount = Number(this.form.shippingPayAmount) || 0
      const newPayAmount = newGoodsAmount + shippingPayAmount
      // 实付金额不能低于成本价（含运费）
      if (newPayAmount < totalCostPrice + shippingPayAmount) {
        this.$message.warning('实付金额不能低于成本价（' + (totalCostPrice + shippingPayAmount).toFixed(2) + '）')
        return false
      }
      // 公式校验：payAmount * 0.74 > totalOriginalPrice * 0.5
      if (newPayAmount * 0.74 <= totalOriginalPrice * 0.5) {
        const minPayAmount = (totalOriginalPrice * 0.5 / 0.74).toFixed(2)
        this.$message.warning('实付金额不满足公式要求，最低实付金额为' + minPayAmount)
        return false
      }
      return true
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          if (!this.validatePrice()) {
            return
          }
          this.submitLoading = true
          const itemList = this.listOrder.map(row => ({
            orderItemId: row.orderItemId,
            newPayPrice: Number(row.newPayPrice)
          }))
          const obj = {
            id: this.form.id,
            itemList,
            approvalOpinion: this.form.approvalOpinion
          }
          updatePriceApi(obj).then(response => {
            if (response) {
              this.visible = false
              this.$message.success(response.data)
              this.$emit('updateCollback')
            }
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
